module.exports = __webpack_public_path__ + "static/media/email-icon.2b4e9a55.svg";